var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M17.246 8.586h-6.49v11.662h6.49z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M11.167 14.417A7.4 7.4 0 0 1 14 8.586a7.417 7.417 0 1 0 0 11.662 7.4 7.4 0 0 1-2.833-5.831"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M26 14.417a7.416 7.416 0 0 1-12 5.83 7.418 7.418 0 0 0 0-11.661 7.416 7.416 0 0 1 12 5.83"
  })));
};
export default SvgMastercard;